export default __webpack_public_path__ + "static/media/bg1.e7ae9a3f.jpg";